var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import _ from 'lodash';
import React, { Component } from 'react';
function fromEntries(pairs) {
    return pairs.reduce(function (acc, pair) {
        acc[pair[0]] = pair[1];
        return acc;
    }, {});
}
export var withModules = function (modules, Placeholder) {
    if (Placeholder === void 0) { Placeholder = function () { return null; }; }
    return function (CompClass) {
        return /** @class */ (function (_super) {
            __extends(WithModules, _super);
            function WithModules() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.state = {
                    loadedModules: {},
                };
                return _this;
            }
            WithModules.prototype.componentDidMount = function () {
                var _this = this;
                var pairs = Object.entries(modules);
                Promise.all(pairs.map(function (_a) {
                    var name = _a[0], loadModule = _a[1];
                    return loadModule().then(function (mod) { return [name, mod]; });
                })).then(function (fetchedModules) {
                    _this.setState({ loadedModules: fromEntries(fetchedModules) });
                });
            };
            WithModules.prototype.render = function () {
                return _.isEmpty(this.state.loadedModules) ? (React.createElement(Placeholder, null)) : (React.createElement(CompClass, __assign({}, this.state.loadedModules, this.props)));
            };
            return WithModules;
        }(Component));
    };
};
